function ctx() {
  return new (window.AudioContext || window.webkitAudioContext)();
}

// Short "ping" for new messages
export function playMessageSound() {
  try {
    const ac = ctx();
    const osc = ac.createOscillator();
    const gain = ac.createGain();
    osc.connect(gain);
    gain.connect(ac.destination);
    osc.type = 'sine';
    osc.frequency.setValueAtTime(880, ac.currentTime);
    osc.frequency.exponentialRampToValueAtTime(660, ac.currentTime + 0.12);
    gain.gain.setValueAtTime(0.18, ac.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ac.currentTime + 0.28);
    osc.start(ac.currentTime);
    osc.stop(ac.currentTime + 0.3);
  } catch {}
}

// "Cha-ching" cash register — plays for new provider orders
export function playOrderSound() {
  try {
    const ac = ctx();
    // Notes: short metallic strike + ring
    [
      { freq: 1568, start: 0,    dur: 0.08, vol: 0.4 },
      { freq: 1318, start: 0.05, dur: 0.08, vol: 0.35 },
      { freq: 2093, start: 0.10, dur: 0.06, vol: 0.5 },
      { freq: 2637, start: 0.14, dur: 0.5,  vol: 0.3 },
    ].forEach(({ freq, start, dur, vol }) => {
      const osc = ac.createOscillator();
      const gain = ac.createGain();
      osc.connect(gain);
      gain.connect(ac.destination);
      osc.type = 'triangle';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(vol, ac.currentTime + start);
      gain.gain.exponentialRampToValueAtTime(0.001, ac.currentTime + start + dur);
      osc.start(ac.currentTime + start);
      osc.stop(ac.currentTime + start + dur + 0.01);
    });
  } catch {}
}
